<template>
    <transition name="modal-fade">
        <div class="modalForm-backdrop">
            <div class="modalForm" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">
                <header class="modalForm-header" id="modalTitle">
                    <slot name="header">
                        <button type="button" class="modalForm-close" @click="close" aria-label="Close modal">x</button>
                    </slot>
                </header>
                <section class="modalForm-body" id="modalDescription">
                    <slot name="body"></slot>
                </section>
                <footer class="modalForm-footer">
                    <slot name="footer"></slot>
                </footer>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: 'modal',
        methods: {
            close() {
                this.$emit('close');
            },
        },
    };
</script>

<style  lang="stylus">
    .modal-fade-enter,
    .modal-fade-leave-active
        opacity 0

    .modal-fade-enter-active,
    .modal-fade-leave-active
        transition opacity .5s ease

    .modalForm-backdrop
        position fixed
        top 0
        bottom 0
        left 0
        right 0
        background-color rgba(0, 0, 0, 0.3)
        display flex
        justify-content center
        align-items center
        z-index 99999

    .modalForm
        position relative
        background #FFFFFF
        box-shadow 2px 2px 20px 1px
        overflow-x hidden
        display flex
        flex-direction column
        width 800px
        max-width 90%
        max-height 90%
        overflow-y auto

    .modalForm-header,
    .modalForm-footer
        padding 15px
        display flex

    .modalForm-header
        color #4AAE9B
        justify-content space-between
        height 40px

    .modalForm-footer
        justify-content flex-end

    .modalForm-body
        position relative
        padding 20px 10px

        h2
            margin-top -20px

        .row
            margin-bottom 0 !important

        .error
            &.pretty-select
                border-color #ff4963 !important
                border-width 2px !important

            &.pretty-radio
                .pretty-radio__title:before
                    border-color #ff4963 !important

            input
                border-color #ff4963 !important
                border-width 2px !important

        .form
            display flex
            flex-wrap wrap
            margin-right -1.5rem

            .label
                flex 0 0 100%

                display flex
                flex-direction column
                max-width 50%
                margin-bottom 2.5rem
                padding-right 1.5rem

                @media(max-width 767px)
                    max-width 100%

                &--textarea
                    max-width 100%

            .input
                margin-top 5px
                font-family VWAGTheSansRegular
                font-size 15px
                font-weight normal

                &[type=text],
                &[type=textarea]
                    border solid 1px #a8adb3
                    box-shadow none
                    border-radius 0
                    width 100%
                    padding 0 1rem

                &--text
                    height 4.4rem

                &--textarea
                    min-height 25rem

            // Pretty Radio box
            .pretty-radio
                flex 0 0 100%
                display flex
                justify-items flex-start

                @media(max-width 767px)
                    flex-wrap wrap

                &__title
                    margin-right 1.5rem

                    @media(max-width 767px)
                        flex 0 0 100%
                        margin-bottom 5px


                .label--radio
                    flex 0 0 auto
                    max-width unset
                    display flex
                    position relative
                    overflow hidden
                    flex-direction row
                    justify-items  flex-start
                    align-items center
                    padding-left 3.5rem
                    padding-right 0
                    cursor pointer

                    &:not(:last-child)
                        margin-right 1.5rem

                    .input
                        position absolute
                        left -9999em
                        max-width auto
                        width auto

                    // check markers
                    span
                        &:before
                            display block
                            position absolute
                            left 0
                            top 50%
                            transform translateY(-50%)
                            content ''
                            width 2.4rem
                            height 2.4rem
                            border solid 1px #a8adb3
                            box-shadow none
                            border-radius 50%
                            cursor pointer

                    .input:checked + span
                        &:after
                            display block
                            position absolute
                            left 5px
                            top 50%
                            transform translateY(-50%)
                            content ''
                            width 1.4rem
                            height 1.4rem
                            box-shadow none
                            background-color $color-blue-petrol
                            border-radius 50%
                            cursor pointer

            // PRETTY SELECTS
            .pretty-select
                border 1px solid #a8adb3
                position relative
                overflow hidden
                margin-top 5px

                &.focused
                    border-color $color-blue-petrol

                &:after
                    content ''
                    position absolute
                    z-index 10
                    right 0
                    top 0
                    height 100%
                    width 40px
                    background url('~@/assets/img/menu-arrow-down.svg') no-repeat #fff 50% 50%
                    pointer-events none
                    cursor pointer

                select
                    padding 0 8px
                    height 42px
                    width 100%
                    border none
                    box-shadow none
                    background transparent
                    background-image none
                    padding-right 40px !important
                    -webkit-appearance none
                    -moz-appearance none
                    appearance none
                    color #4c5356

                    &:focus,
                    &:active
                        border none
                        outline none

                    &::-ms-expand
                        display none

    .modalForm-close
        position absolute
        top 0
        right 0
        border none
        font-size 20px
        line-height 20px
        padding 10px 20px
        cursor pointer
        font-weight bold
        color #b3f2f7
        background transparent

        &:hover
            color #66e4ee

</style>